module.exports = __webpack_public_path__ + "static/media/mobile-6-1.67860fde.gif";